import React from 'react';
import './MeetingFormSkeleton.css';

/**
 * Skeleton loader for meeting form fields
 */
const MeetingFormSkeleton = () => {
  return (
    <div className="meeting-form-skeleton">
      {/* Title Field */}
      <div className="form-skeleton-group">
        <div className="skeleton-label" />
        <div className="skeleton-input" />
      </div>

      {/* Description Field */}
      <div className="form-skeleton-group">
        <div className="skeleton-label" />
        <div className="skeleton-textarea" />
      </div>

      {/* DateTime Row */}
      <div className="form-skeleton-datetime-row">
        <div className="form-skeleton-group">
          <div className="skeleton-label" />
          <div className="skeleton-input" />
        </div>
        <div className="form-skeleton-group">
          <div className="skeleton-label" />
          <div className="skeleton-input" />
        </div>
        <div className="form-skeleton-group">
          <div className="skeleton-label" />
          <div className="skeleton-input" />
        </div>
        <div className="form-skeleton-group">
          <div className="skeleton-label" />
          <div className="skeleton-input" />
        </div>
        <div className="form-skeleton-group">
          <div className="skeleton-label" />
          <div className="skeleton-input" />
        </div>
      </div>

      {/* Location Row */}
      <div className="form-skeleton-group">
        <div className="skeleton-label" />
        <div className="skeleton-input" style={{ width: '60%' }} />
      </div>

      {/* Invite Members */}
      <div className="form-skeleton-group">
        <div className="skeleton-label" />
        <div className="skeleton-select" />
      </div>
    </div>
  );
};

export default MeetingFormSkeleton;
